<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title class="mb-2" primary-title>
        Créditos IA
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <app-number-field v-model="form.ia_credits" label="Créditos IA" :precision="0" />
          </v-col>
          <v-col>
            <app-number-field v-model="form.ia_used_credits" label="Créditos IA Usados" :precision="0" />
          </v-col>
        </v-row>

      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false" text>Cancelar</v-btn>
        <v-btn @click="handleSave()" class="mr-2" color="primary">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      baseForm: {
        company_id: null,
        is_free_account: 0,
        is_beta_tester: false,
        free_trial_ends_at: null,
        no_block_access_before: null,
        type: null,
        professionals_limit: null,
        attendants_limit: null,
      },
      form: {},

      typeOptions: [
        { text: "Individual", value: "individual" },
        { text: "Clínica", value: "clinic" },
      ],

      dialog: false,
    };
  },
  created() {
    this.reset();
  },
  computed: {},
  methods: {
    open(user_id) {
      this.reset();
      this.$loading.start();
      this.$http
        .show("admin/users", user_id)
        .then((response) => {
          this.$loading.finish();
          this.setForm(response.user);
          this.dialog = true;
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
    reset() {
      this.form = JSON.parse(JSON.stringify(this.baseForm));
    },

    setForm(user) {
      this.form = {
        id: user.id,
        ia_used_credits: user.ia_used_credits,
        ia_credits: user.ia_credits,

      };
    },

    handleSave() {
      this.$loading.start();
      this.$http
        .update("admin/ia-usage", this.form.id, this.form)
        .then((response) => {
          this.$loading.finish();
          this.dialog = false;
          this.$emit("store", this.form.id);
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style></style>